<template>
	<v-row>
		<v-col cols="12" class="py-1">
			<p class="mb-1 text-center text-h6">{{ item.comprobacion }}</p>
		</v-col>
		<v-divider class="mx-4" />
		<template v-if="item.tipoComprobacion != null">
			<v-col cols="12">
				<RespuestaItem
					v-model="item.respuesta"
					:tipoComprobacion="item.tipoComprobacion"
					:opciones="item.opciones"
					:disabled="disabled"
					:error-message.sync="item.errorRespuesta"
				/>
			</v-col>
			<v-divider class="mx-4" />
		</template>
		<v-col cols="12" class="py-1">
			<RecursosChips
				:documentos="item.documentos"
				:links="item.links"
			/>
		</v-col>
		<v-divider class="mx-4" />
		<v-col cols="12" class="py-2">
			<SwitchButtons
				v-model="item.satisfactoria"
				label="¿Satisfactoria?"
				:disabled="disabled"
				:error-message="item.errorSatisfactoria"
				@change="onChangeSwitchSatisfactoria()"
			/>
		</v-col>
		<template v-if="item.satisfactoria == false">
			<v-col cols="12" :class="{ 'pt-8': !isMobile }">
				<v-textarea
					v-model="item.comentario"
					label="Comentarios"
					outlined
					clearable
					auto-grow
					rows="2"
					:disabled="disabled"
					hide-details
				></v-textarea>
			</v-col>
			<v-col cols="12">
				<Imagenes
					v-model="item.idsDocumentos"
					:disabled="disabled"
					:nombreComprobacion="item.comprobacion"
					:documentosRegistrados="item.documentosRegistrados"
				/>
			</v-col>
			<v-col cols="12">
				<SwitchButtons
					v-model="item.resuelto"
					label="¿Se solucionó?"
					:disabled="disabled"
					:error-message="item.errorResuelto"
					@change="$set(item,'errorResuelto',null)"
				/>
			</v-col>
		</template>
		<v-divider class="mx-4 my-2" />
		<v-col cols="12" class="py-1">
			<v-textarea
				v-model="item.notas"
				label="Notas"
				outlined
				clearable
				auto-grow
				rows="2"
				:disabled="disabled"
				hide-details
			></v-textarea>
		</v-col>
	</v-row>
</template>

<script>
import Imagenes from "./Imagenes.vue";
import RecursosChips from "./RecursosChips.vue";
import RespuestaItem from './RespuestaItem.vue';
import SwitchButtons from "./SwitchButtons.vue";

export default {
	components: { RecursosChips, SwitchButtons, Imagenes, RespuestaItem },
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
		comprobacion: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			item: this.comprobacion,
		};
	},
	methods: {
		onChangeSwitchSatisfactoria() {
			this.$set(this.item, "comentario", null);
			this.$set(this.item, "idsDocumentos", []);
			this.$set(this.item, "resuelto", null);
			this.$set(this.item, "errorSatisfactoria", null);
			this.$set(this.item, "errorResuelto", null);
		},
	},
};
</script>